import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-edit-view-actions',
  templateUrl: './edit-view-actions.component.html',
  styleUrls: ['./edit-view-actions.component.scss']
})
export class EditViewActionsComponent implements OnInit {
    @Input() disabled: boolean = true;
    @Output() completed = new EventEmitter();
    @Input() completeText!: string;
    @Output() cancelled = new EventEmitter();
    @Output() debug = new EventEmitter();
    @Input() cancelText!: string;
    @Input() hideCancelButton: boolean = false;
    adminUser: boolean = false;

    constructor(private auth: AuthService) { }

    ngOnInit(): void {
        this.adminUser = this.auth.getCurrentUser.systemAdmin && this.debug.observers.length > 0;
    }

    executeComplete(){
        this.completed.emit();
    }

    executeCancel(){
        this.cancelled.emit();
    }

    executeDebug(){
        this.debug.emit();
    }
}